<template>
    <main>
        <el-form @submit.prevent="login">
            <el-form-item :error=error :show-message="error.length>0">
                <el-input v-model=username
                          class="ri-input"
                          @keypress.enter.native="login"
                          placeholder="Username"
                          minlength="1"
                          maxlength="20"
                          autofocus>
                </el-input>
                <el-input v-model=password
                          class="ri-input"
                          type="password"
                          @keypress.enter.native="login"
                          placeholder="Password"
                          minlength="1"
                >
                </el-input>
            </el-form-item>
        </el-form>
    </main>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import account from "../api/account";

    export default {
        props: {},
        components: {},
        data() {
            return {username: '', password: '', error: ''}
        },
        methods: {
            ...mapActions([]),
            login() {
                account.login(this.username, this.password).then(({error, success}) => {
                    if (!!error)
                        this.error = error
                    console.log(success)
                }).catch(e => {
                    this.error = e.message
                })
            }
        },
        computed: {
            ...mapGetters([]),
        },

    }
</script>

<style lang='scss' scoped>

</style>